var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.7002C17.705 1.7002 19.3524 2.40333 20.5762 3.6747C21.8018 4.94802 22.5 6.68681 22.5 8.51131C22.5 10.3358 21.8018 12.0746 20.5762 13.3479C19.3524 14.6193 17.705 15.3224 16 15.3224C14.295 15.3224 12.6476 14.6193 11.4238 13.3479C10.1982 12.0746 9.5 10.3358 9.5 8.51131C9.5 6.68681 10.1982 4.94802 11.4238 3.6747C12.6476 2.40333 14.295 1.7002 16 1.7002ZM16 22.478C20.2297 22.478 23.9828 23.371 26.6236 24.7427C29.3382 26.1528 30.5 27.837 30.5 29.2891V31.9446H1.5V29.2891C1.5 27.837 2.66181 26.1528 5.37645 24.7427C8.01722 23.371 11.7703 22.478 16 22.478Z",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.c609aa79e901a6eaa7b1568c09db2b35.svg";
export { ForwardRef as ReactComponent };